
const ReviewImagesEvents = {
  REVIEW_IMAGES_FAILED: 'REVIEW_IMAGES_FAILED',
  REVIEW_IMAGES_SUCCESS: 'REVIEW_IMAGES_SUCCESS',
  REVIEW_IMAGES_FETCHING: 'REVIEW_IMAGES_FETCHING',
  REVIEW_IMAGES_NOT_FOUND: 'REVIEW_IMAGES_NOT_FOUND',
  REVIEW_LIKE: 'REVIEW_LIKE',
};

export default ReviewImagesEvents;
